import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useRef } from "react"
import styled from "styled-components"
import { useRenderOn } from "../../hooks/useRenderOn"

import Dropdown from "react-bootstrap/Dropdown"
import { navLinks } from "./navLinks"
import media from "../../helpers/media"

import { dots } from "../../assets"

const Wrapper = styled.header`
  background: var(--color-grey);
  color: var(--color-grey-2);
  display: flex;
  justify-content: space-between;
  /* height: 5vh; */
  height: 50px;
  position: relative;
`

const Title = styled.h1`
  z-index: 5;
  margin: 0;
  display: flex;
  align-items: center;
`

const Nav = styled.nav`
  display: flex;
  align-items: center;
`

const StyledLink = styled(Link)`
  color: var(--color-grey-2);
  padding: 0 30px;
  text-decoration: none;
  text-transform: lowercase;
  height: 100%;
  display: flex;
  align-items: center;

  &:hover {
    background-color: white;
    color: inherit;
    text-decoration: none;
  }
`
const LogoLink = styled(StyledLink)`
  padding: 0 20px;
  font-family: var(--font-primary);
  font-size: var(--font-size-xl);

  ${media.tablet} {
    padding: 0 30px;
  }
`
const NavLink = styled(StyledLink)`
  font-size: var(--font-size-sm);

  img {
    width: 8px;
    transform: translateY(-2px);
    margin-right: 4px;
  }
`

const FiltersDropdown = styled(Dropdown)`
  display: inline-block;

  &.hidden {
    visibility: hidden;
  }

  #toggleFilters {
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;

    &:after {
      content: initial;
    }
  }

  img {
    width: 18px;
  }
`

const MenuDropdown = styled(Dropdown)`
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: flex-end;

  /* &.hidden {
    visibility: hidden;
  }*/

  #toggleMobileMenu {
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
    color: black;
    height: 100%;
    position: initial;
    padding-right: 20px;
    padding-left: 20px;

    &:after {
      content: initial;
    }

    ${media.tablet} {
      padding-right: 30px;
      padding-left: 30px;
    }
  }

  && img {
    width: 10px;
    transform: translateY(0px);
    margin-right: 5px;

    &#dots-menu {
      width: 15px;
    }
  }
`
const DropdownList = styled(Dropdown.Menu)`
  padding: 0;
  background-color: var(--color-light-1);
  border: 1px solid var(--color-light-2);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  width: 100%;
  margin-top: -2px;

  .dropdown-item {
    padding: 0;
    &:active {
      background: none;
    }
  }
`
const DropdownItem = styled(NavLink)`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  border: 0;
  background: inherit;
  font: inherit;
  outline: 0;
  padding: 15px 20px;
  text-align: inherit;
  white-space: nowrap;
  width: 100%;

  &:not(:first-child) {
    border-top: 1px solid var(--color-light-2);
  }

  &:hover {
    background: var(--color-grey);
  }
  &:focus {
    outline: 0;
  }
  &.active {
    background: var(--color-light-2);
  }
`

const Name = styled.span``

const MenuMobile = () => {
  return (
    <MenuDropdown alignRight>
      <Dropdown.Toggle id="toggleMobileMenu">
        {/* ... */}
        <img src={dots} alt="menu" id="dots-menu" />
      </Dropdown.Toggle>

      <DropdownList>
        {navLinks.map((item, i: number) => (
          <Dropdown.Item key={i} eventKey={"button" + i} as="button">
            <DropdownItem to={item.to} key={i}>
              {item.name}
            </DropdownItem>
          </Dropdown.Item>
        ))}
      </DropdownList>
    </MenuDropdown>
  )
}

const Menu = () => (
  <Nav>
    {navLinks
      .filter(item => item.onlyMobile === false)
      .map((item, i) => (
        <NavLink to={item.to} key={i}>
          <span>{item.name}</span>
        </NavLink>
      ))}
  </Nav>
)

interface IProps {
  siteTitle?: string
}

const Header = ({ siteTitle }: IProps) => {
  const { lgOrUp } = useRenderOn()

  return (
    <Wrapper id="navigation">
      <Title>
        <LogoLink to="/">{siteTitle}</LogoLink>
      </Title>
      {lgOrUp ? <Menu /> : <MenuMobile />}
    </Wrapper>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
